export default function matchPath(currentPath, pathList) {
  if (!Array.isArray(pathList) || pathList.length === 0) return true; // Sem restrições (Lista vazia): exibe em todas as páginas

  return pathList.some(pathPattern => {
    if (!pathPattern || typeof pathPattern !== 'string') return false;

    if (currentPath === pathPattern) return true;

    const cleanPattern = pathPattern.startsWith('/') ? pathPattern : `/${pathPattern}`;

    const normalizedPattern = cleanPattern.replace(/\*/g, '[^/]+').replace(/:[a-zA-Z]+/g, '[^/]+');

    const regex = new RegExp(`^${normalizedPattern}$`);
    if (regex.test(currentPath)) return true;

    const relativeRegex = new RegExp(`${normalizedPattern}$`);
    return relativeRegex.test(currentPath);
  });
}
